module.exports = __webpack_public_path__ + "static/anardooni-4029d899bdd32b971b03b806a89fbfb9.png";